import { DictionaryType } from '../types/DictionaryType';

class TranslationService {
  translations: DictionaryType<string> = {};

  constructor() {
    this.translations = {};
  }

  setTranslations(translations: DictionaryType<string>) {
    this.translations = translations;
  }

  translate(text: string) {
    return this.translations.hasOwnProperty(text) ? this.translations[text] : text;
  }

  translateAndFillPlaceholders(text: string, placeholders: string[]): string {
    const translation = this.translations[text] ?? text;

    return translation.replace(/{(\d+)}/g, (match, number) => placeholders[number] ?? match);
  }
}

export default new TranslationService();
